import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface StatusContext {
  statusMessage: string;
  setStatusMessage: (message: string) => void;
  clearStatusMessage: () => void;
}

const StatusContext = createContext<StatusContext | null>(null);

export const StatusContextProvider = ({ children }: PropsWithChildren) => {
  const [statusMessage, setStatusMessage] = useState<string>('');

  const clearStatusMessage = () => {
    setStatusMessage('');
  };

  return (
    <StatusContext.Provider
      value={{ statusMessage, setStatusMessage, clearStatusMessage }}
    >
      {children}
    </StatusContext.Provider>
  );
};

export const useStatusContext = () => {
  const statusContext = useContext(StatusContext);

  if (!statusContext) {
    throw new Error(
      'useStatusContext must be used within StatusContextProvider'
    );
  }
  return statusContext;
};
